



















import { Vue, Component, Prop } from 'vue-property-decorator'
import { RouteConfig } from 'vue-router'
import { chooseIcon, isHidden, isSub } from './sidebar'

@Component({
  name: 'MenuItem'
})
export default class MenuItem extends Vue {
  @Prop({ type: Object, required: true }) route!: RouteConfig

  get isHidden() {
    return isHidden(this.route)
  }

  get isSub() {
    return isSub(this.route)
  }

  get icon() {
    return chooseIcon(this.route)
  }
}
